// Series data - 6 bodies of work in chronological order
// To add images later, simply add new objects to the `works` array of each series

export const seriesList = [
  {
    slug: "a-portrait-of-perth-prison",
    title: "A Portrait of Perth Prison",
    order: 1,
    description: "An intimate portrait series examining the institutional walls of Perth Prison, exploring confinement, state-imposed isolation, and the human cost of carceral systems.",
    works: []
  },
  {
    slug: "scotland-the-brave",
    title: "Scotland The Brave",
    order: 2,
    description: "A critical interrogation of Scottish national identity, mythologies of bravery, and the political landscape of contemporary Scotland.",
    works: []
  },
  {
    slug: "fun-and-games",
    title: "Fun & Games",
    order: 3,
    description: "A satirical exploration of the games played by power — exposing the absurdity beneath political theatre and institutional performance.",
    works: []
  },
  {
    slug: "fun-and-games-too",
    title: "Fun & Games Too",
    order: 4,
    description: "A continuation and intensification of the Fun & Games series, pushing further into the theatre of political deception and systemic farce.",
    works: [
      {
        id: "fgt-1",
        title: "Morbid Symptoms II (The Concept of Culture is Bound Up with Administration)",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/jvewsv6d_20260207_111944.jpg"
      },
      {
        id: "fgt-2",
        title: "Catterline (Special Economic Zone)",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/gg7p0xsr_20260207_115647%281%29.jpg"
      },
      {
        id: "fgt-3",
        title: "The Vampiric Institution (Past / Present)",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/1lt299xt_20260213_100715.jpg"
      },
      {
        id: "fgt-4",
        title: "Flotsam (Catterline / Firth of Forth)",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/zfctrypw_20260213_100738.jpg"
      }
    ]
  },
  {
    slug: "golgotha",
    title: "Golgotha",
    order: 5,
    description: "A meditation on suffering, sacrifice, and martyrdom in the contemporary political moment — drawing on the iconography of the Place of the Skull.",
    works: []
  },
  {
    slug: "golgotha-too",
    title: "Golgotha Too",
    order: 6,
    description: "A continuation of Golgotha — extending the meditation on sacrifice, the Angel of History, and the violence of progress. Crucified forms, mutilated angels and the iconography of late capitalism, charted across Wall St, Portobello, and Daisyworld.",
    works: [
      {
        id: "gt-1",
        title: "Two Crucifixions",
        year: 2025,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/spx8lwk8_20251111_090140.jpg"
      },
      {
        id: "gt-2",
        title: "A Prophecy Foretold (A Brutalised Thing Is Blown Backwards Into The Future)",
        year: 2025,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/cxsot3yh_20251215_141425.jpg"
      },
      {
        id: "gt-3",
        title: "The Problem with Pollutants II",
        year: 2025,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/4jgwgq3e_20251215_141444.jpg"
      },
      {
        id: "gt-4",
        title: "The Angel of History (A History of Barbarism)",
        year: 2025,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/aud5h1te_20251215_141517.jpg"
      },
      {
        id: "gt-5",
        title: "The Dead Angel Rises From The Sea (Blood Tide)",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/ddvu6cif_20260103_105101.jpg"
      },
      {
        id: "gt-6",
        title: "Daisyworld Amen (Future / Present / Past)",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/4glprw6h_20260105_123711.jpg"
      },
      {
        id: "gt-7",
        title: "The Problem With Causal Networks (Angelus Novus Dismembered)",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/sl29ikh9_20260105_123805.jpg"
      }
    ]
  },
  {
    slug: "epic-fury",
    title: "Epic Fury",
    order: 7,
    description: "The most recent body of work. Densely layered acrylic compositions confronting the spirit of nothingness, the formalist avant-garde, war as magic, and the mendacity of neoliberal institutions. A visual reckoning with our dark times.",
    works: [
      {
        id: "ef-1",
        title: "The Spirit of Nothingness",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/j9mqc6ho_20260306_164415.jpg"
      },
      {
        id: "ef-2",
        title: "The Dark Negative Death Trend",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/p59rva4v_20260309_165227.jpg"
      },
      {
        id: "ef-3",
        title: "En Media Rais",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/7i0eqn9u_20260312_070740.jpg"
      },
      {
        id: "ef-4",
        title: "Allegories of Inauthentic Structures II",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/hvoyr732_20260313_113158.jpg"
      },
      {
        id: "ef-5",
        title: "It Is Finished",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/usxfyu19_20260322_124631.jpg"
      },
      {
        id: "ef-6",
        title: "The Malefic Machine of Destruction",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/nr70psla_20260322_115053.jpg"
      },
      {
        id: "ef-7",
        title: "Allegories of Inauthentic Structures Pt. V",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/7vjuh2u2_20260322_123808%281%29.jpg"
      },
      {
        id: "ef-8",
        title: "Allegories of Inauthentic Structures Pt. IV",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/2hgd4vik_20260402_102340.jpg"
      },
      {
        id: "ef-9",
        title: "Meanwhile (Royal Scottish Academy)",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/stwuef7w_20260419_140412.jpg"
      },
      {
        id: "ef-10",
        title: "War Is Magical",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/i5sshuj5_20260509_134958.jpg"
      },
      {
        id: "ef-11",
        title: "The Problem with Fetishes Part IV",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/nmdm2trm_20260516_114322.jpg"
      },
      {
        id: "ef-12",
        title: "Allegories of Inauthentic Structures - Part IV",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/u2xule4r_20260516_173854.jpg"
      },
      {
        id: "ef-13",
        title: "The Problem of Culture as Condiment Pt. V",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/1k0gwgja_20260522_175738.jpg"
      },
      {
        id: "ef-14",
        title: "The Problems With The Formalist Minimalist Alliance Pt. 1",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/799gnnlz_20260406_135236.jpg"
      },
      {
        id: "ef-15",
        title: "Allegories of Inauthentic Structures Pt. V",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/odak25qa_20260406_140239.jpg"
      },
      {
        id: "ef-16",
        title: "Missiles Fired From Moral High Ground Part III",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/lbp10w7l_20260406_143652.jpg"
      },
      {
        id: "ef-17",
        title: "The Problem With Glory Hunters",
        year: 2026,
        medium: "Acrylic on board",
        dimensions: "TBD",
        image: "https://customer-assets.emergentagent.com/job_contemporary-canvas/artifacts/c5kexqz3_20260406_143657.jpg"
      }
    ]
  }
];

export const getSeriesBySlug = (slug) => {
  return seriesList.find(s => s.slug === slug);
};
